import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import TableCommentingToProduct from '../AdvanceSearchEcommerce/TableCommentingToProduct';
import { IEcommerceProductHierarchyItem } from 'src/models/ecommerce';
import { useState } from 'react';
import { useDebounce } from 'src/hooks/useDebounce';
import useEcommerce from 'src/services/useEcommerce';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { Close } from '@mui/icons-material';
import { reducerUpdateAdvanceSearch } from 'src/features/advanceSearchEcommerce';

export default function ModalCommentingToProduct({
  open,
  handleClose,
  selectedProducts,
  onSelectedProductsChange
}: {
  open: boolean;
  handleClose: () => void;
  selectedProducts: IEcommerceProductHierarchyItem[];
  onSelectedProductsChange?: (
    products: IEcommerceProductHierarchyItem[]
  ) => void;
}) {
  const [searchValue, setSearchValue] = useState<string>('');
  const [debouncedState, setDebouncedState] = useDebounce('');
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const projectId = useAppSelector((state) => state.users.project.id);
  const advanceSearchEcommerce = useAppSelector(
    (state) => state.storeAdvancedSearchEcommerce
  );
  const objectIdList = useAppSelector(
    (state) => state.analyticArguments.objectIdList
  );

  const { useGetEcommerceStreamCommentingToProduct } = useEcommerce();

  const {
    data: streamsCommentingToPostData,
    loading: loadingStreamsCommentingToPost
  } = useGetEcommerceStreamCommentingToProduct({
    skip: !open,
    variables: {
      projectId: projectId,
      name: debouncedState,
      objectIds: objectIdList
    },
    fetchPolicy: 'network-only'
  });

  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const keyword = event.target.value;
    setSearchValue(keyword);
    setDebouncedState(() => keyword);
  };

  const handleDone = () => {
    dispatch(
      reducerUpdateAdvanceSearch({
        ...advanceSearchEcommerce,
        replyToOriginalId: selectedProducts.map((stream) => stream.originalId),
        selectedOriginalToPost: selectedProducts,
        searchOriginalToPost: debouncedState
      })
    );
    handleClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2 }}
        >
          <Typography fontWeight={600}>Commenting to Product</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <Close />
          </IconButton>
        </Stack>
        <DialogContent>
          <TableCommentingToProduct
            data={
              streamsCommentingToPostData?.ecommerceProductManagement_getProductHierarchy ||
              []
            }
            loading={loadingStreamsCommentingToPost}
            searchValue={searchValue}
            handleChangeSearchValue={handleChangeSearch}
            selectedProducts={selectedProducts}
            onSelectedProductsChange={onSelectedProductsChange}
          />
        </DialogContent>
        <Box display="flex" justifyContent="center" my={theme.spacing(2)}>
          <Button
            variant="contained"
            size="large"
            sx={{
              background: theme.palette.primary.dark
            }}
            onClick={handleDone}
          >
            Submit
          </Button>
        </Box>
      </Dialog>
    </>
  );
}
